import { RootState } from '../../../../store/rootReducer'

export const dolyameSelector = (state: RootState) => state.app.DOLYAME
